import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@pinnakl/auth/providers';
import { PrimeButtonComponent } from '@pinnakl/shared/ui/prime';
import { InlineSVGModule } from '@pinnakl/shared/util-providers';

@Component({
  selector: 'auth-recovery-panel',
  templateUrl: './auth-recovery-panel.component.html',
  styleUrl: './auth-recovery-panel.component.scss',
  imports: [InlineSVGModule, PrimeButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthRecoveryPanelComponent {
  private readonly authService = inject(AuthService);

  protected readonly failure = this.authService.authFailure;

  protected retry(): void {
    this.authService.retryAuth();
  }
}
